import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.completed = false
    this.checkCompletion = this.checkCompletion.bind(this)

    // 使用 passive 监听器优化性能
    window.addEventListener("scroll", this.checkCompletion, { passive: true })

    // 初始检查（可能内容很短不需要滚动）
    setTimeout(() => this.checkCompletion(), 500)
  }

  disconnect() {
    window.removeEventListener("scroll", this.checkCompletion)
  }

  checkCompletion() {
    if (this.completed) return

    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const windowHeight = window.innerHeight
    const documentHeight = document.documentElement.scrollHeight

    // 对于很短的内容，要求滚动到底；对长内容采用 90% 阈值
    const shortContent = documentHeight <= windowHeight * 1.2
    const scrollPercentage = (scrollTop + windowHeight) / documentHeight

    if ((shortContent && scrollPercentage >= 1) || scrollPercentage >= 0.9) {
      this.markCompleted()
    }
  }

  markCompleted() {
    if (this.completed || !this.urlValue) return
    this.completed = true

    // 获取 CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      credentials: "same-origin"
    }).catch(error => {
      console.error("Failed to mark as completed:", error)
      // 允许在网络异常时重试
      this.completed = false
    })
  }
}
